import { postRequest } from "@/assets/utils/api";
// 获取url的参数；
export const getQueryString = name => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); //构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg); //匹配目标参数
  if (r != null) return unescape(r[2]); //返回解码参数值
  return null; //返回参数值
};
//添加缓存；
export const setData = (
  openid,
  nickname,
  avatar,
  sex,
  unionid,
  token,
  userID
) => {
  localStorage.setItem("openid", openid);
  localStorage.setItem("nickname", nickname);
  localStorage.setItem("avatar", avatar);
  localStorage.setItem("sex", sex);
  localStorage.setItem("unionid", unionid);
  if (token) {
    localStorage.setItem("user_id", userID);
    localStorage.setItem("token", token);
  } else {
    localStorage.setItem("user_id", 0);
    localStorage.setItem("token", 0);
  }
};
// 获取openid;
export const openId = () => {
  // return o_kTswUOZBUXKBOQlZG2TI7P5bIo
  if (localStorage.getItem("openid")) {
    return localStorage.getItem("openid");
  } else {
    return false;
  }
};
// 删除所有的缓存
export const removeStorage = () => {
  localStorage.removeItem("user_id");
  localStorage.removeItem("token");
  localStorage.removeItem("openid");
  localStorage.removeItem("avatar");
  localStorage.removeItem("nickname");
  localStorage.removeItem("attention");
  localStorage.removeItem("lastTime");
  localStorage.removeItem("sex");
  localStorage.removeItem("unionid");
};
export const isLogin = () => {
  // return true
  if (localStorage.getItem("openid")) {
    return true;
  } else {
    return false;
  }
};
export const BaseStorage = () => {
  if (
    localStorage.getItem("user_id") &&
    localStorage.getItem("token") &&
    localStorage.getItem("openid")
  ) {
    return {
      user_id: localStorage.getItem("user_id"),
      token: localStorage.getItem("token")
    };
  } else {
    return false;
  }
};
export const isBindPhone = () => {
  if (localStorage.getItem("token") && localStorage.getItem("user_id") != 0) {
    return true;
  } else {
    return false;
  }
};
export const autoTextarea = function(elem, extra, maxHeight, callback) {
  extra = extra || 0;
  var isFirefox = !!document.getBoxObjectFor || "mozInnerScreenX" in window,
    isOpera = !!window.opera && !!window.opera.toString().indexOf("Opera"),
    addEvent = function(type, callback) {
      elem.addEventListener
        ? elem.addEventListener(type, callback, false)
        : elem.attachEvent("on" + type, callback);
    },
    getStyle = elem.currentStyle
      ? function(name) {
          var val = elem.currentStyle[name];

          if (name === "height" && val.search(/px/i) !== 1) {
            var rect = elem.getBoundingClientRect();
            return (
              rect.bottom -
              rect.top -
              parseFloat(getStyle("paddingTop")) -
              parseFloat(getStyle("paddingBottom")) +
              "px"
            );
          }

          return val;
        }
      : function(name) {
          return getComputedStyle(elem, null)[name];
        },
    minHeight = parseFloat(getStyle("height"));

  elem.style.resize = "none";

  var change = function() {
    var scrollTop,
      height,
      padding = 0,
      style = elem.style;

    if (elem._length === elem.value.length) return;
    elem._length = elem.value.length;

    if (!isFirefox && !isOpera) {
      padding =
        parseInt(getStyle("paddingTop")) + parseInt(getStyle("paddingBottom"));
    }
    // scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    // window.scrollTo(0, Math.max(scrollHeight - 1, 0));

    elem.style.height = minHeight + "px";
    if (elem.scrollHeight > minHeight) {
      if (maxHeight && elem.scrollHeight > maxHeight) {
        height = maxHeight - padding;
        style.overflowY = "auto";
      } else {
        height = elem.scrollHeight - padding;
        style.overflowY = "hidden";
      }
      style.height = height + extra + "px";
      console.log(scrollTop);
      scrollTop += parseInt(style.height) - elem.currHeight;
      // document.body.scrollTop = scrollTop;
      // document.documentElement.scrollTop = scrollTop;
      elem.currHeight = parseInt(style.height);
      // console.log(style);
      callback(parseInt(style.height));
    }
  };

  addEvent("propertychange", change);
  addEvent("input", change);
  addEvent("focus", change);
  change();
};

export const debounce = function(func, delay) {
  let timer;

  return function(...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay || 500);
  };
};
export const throttle = function(fn, delay) {
  let enterTime = 0;
  let gapTime = delay || 500;
  return function() {
    var context = this;
    var backTime = new Date();
    if (backTime - enterTime > gapTime) {
      fn.call(context, arguments);
      enterTime = backTime;
    }
  };
};
export const checkPhone = (that, val, data) => {
  return new Promise((resolve, reject) => {
    if (!isBindPhone()) {
      if (val) {
        resolve(false);
      } else {
        that
          .postRequest({
            service: "App.User.LoginByOpenId",
            openid: localStorage.getItem("openid"),
            unionid: localStorage.getItem("unionid")
              ? localStorage.getItem("unionid")
              : ""
          })
          .then(res => {
            if (res.data.ret == 200) {
              var data = res.data.data;
              localStorage.setItem("nickname", data.nickname);
              localStorage.setItem("token", data.token);
              localStorage.setItem("user_id", data.user_id);
              localStorage.setItem("avatar", data.avatar);
              resolve(true);
            } else {
              if (data) {
                that.$bindPhone({
                  opts: () => {
                    that.gotoAdver(data);
                  }
                });
              } else {
                that.$bindPhone({
                  opts: () => {}
                });
              }
              resolve(false);
            }
          });
      }
    } else {
      resolve(true);
    }
  });
};
export const onBridgeReady = () => {
  WeixinJSBridge.call("hideOptionMenu");
};
export const noshare = () => {
  if (typeof WeixinJSBridge == "undefined") {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
      document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
    }
  } else {
    onBridgeReady();
  }
};

export const getOpenId = () => {
  var APPID = apiConfig().APPID;
  var REDIRECT_URI = apiConfig().loginUrl;
  console.log(encodeURIComponent(REDIRECT_URI));
  var url =
    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
    APPID +
    "&redirect_uri=" +
    encodeURIComponent(REDIRECT_URI) +
    "&response_type=code&scope=snsapi_base&state=999#wechat_redirect";
  location.href = url;
};
// export const loginYouZan=()=>{
//     postRequest({service:'App.YouZan_User.Login'}).then(res=>{

//     })
// }
export const login = () => {  
  if (getQueryString("state") == "999") {
    if (getQueryString("code")) {
      return new Promise((resolve, reject) => {
        postRequest({
          service: "WxMessage.login",
          wx_code: getQueryString("code")
        }).then(res => {
          if (res.data.ret == 200) {
            // 当status==0的时候说明没有获取到用户信息；
            if (res.data.data.status == 0) {
              var APPID = apiConfig().APPID;
              var REDIRECT_URI = apiConfig().loginUrl;
              location.href =
                "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
                APPID +
                "&redirect_uri=" +
                encodeURIComponent(REDIRECT_URI) +
                "&response_type=code&scope=snsapi_userinfo&state=666#wechat_redirect";
            } else if (res.data.data.status == 1) {
              resolve(res);
            } else if (res.data.data.status == 2) {
              resolve(res);
            } else {
              console.log(res.data.data);
              alert(res.data.data);
            }
          } else {
            //alert(res.data.msg);
            getOpenId();
          }
        });
      });
    }
  } else if (getQueryString("state") == "666") {
    return new Promise((resolve, reject) => {
      postRequest({
        service: "WxMessage.login_info",
        wx_code: getQueryString("code")
      }).then(res => {
        resolve(res);
      });
    });
  } else {
    return new Promise((resolve, reject) => {
      resolve(false);
      getOpenId();
    });
  }
};
export const pageScroll = (function() {
  const fn = function(e) {
    e.preventDefault();
    e.stopPropagation();
  };
  let islock = false;

  return {
    lock(el) {
      if (islock) return;
      islock = true;
      (el || document).addEventListener("touchmove", fn, { passive: false });
    },
    unlock(el) {
      islock = false;
      (el || document).removeEventListener("touchmove", fn, { passive: false });
    }
  };
})();
export const test = function(t, fun) {
  fun.call(t);
};
var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
var browser = {
  versions: (function() {
    var u = navigator.userAgent,
      app = navigator.appVersion;
    return {
      trident: u.indexOf("Trident") > -1, //IE内核
      presto: u.indexOf("Presto") > -1, //opera内核
      webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
      gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, //android终端
      iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf("iPad") > -1, //是否iPad
      webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
      weixin: u.indexOf("MicroMessenger") > -1, //是否微信 （2015-01-22新增）
      qq: u.match(/\sQQ/i) == " qq" //是否QQ
    };
  })(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
};
export { browser };
export const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
export const isUpdataName = () => {
  return new Promise((resolve, reject) => {});
};
// 检查是否更新昵称和头像
export const checkUpdataMinxin = {
  methods: {
    isUpdataName() {
      return new Promise(resolve => {
        this.postRequest({ service: "App.User.IsUpdNameAvatar" }).then(res => {
          var data = res.data.data;

          if (data.nicknameisupd && data.avatarisupd) {
            //
            resolve(true);
          } else {
            localStorage.setItem(
              "avatornameFlag",
              JSON.stringify(res.data.data)
            );
            this.$router.push({
              path: "/updatabase"
            });
            resolve(false);
          }
        });
      });
    }
  }
};
export const PwdMinxin = {
  methods: {
    confirmSetpwd() {
      this.$confirm({
        title: "提示",
        mes: "您未设置支付密码，是否要去设置",
        opts: [
          {
            txt: "取消",
            color: "#e6e6e6",
            callback: () => {}
          },
          {
            txt: "确定",
            stay: true,
            color: "#ffbc00",
            callback: () => {
              var Element = document.getElementById("confirmContent");
              Element.parentNode.removeChild(Element);
              this.$store.commit("setShowPay", {
                path: "excellent",
                status: true
              });
              this.$router.push({
                path: "/selfsafe",
                query: {
                  type: "new"
                }
              });
            }
          }
        ]
      });
    }
  }
};

function setCookie(c_name, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie =
    c_name +
    "=" +
    escape(value) +
    (expiredays == null ? "" : ";expires=" + exdate.toGMTString()) +
    ";path=/;domain=nbthinking.com";
}
export const refreshToken = (that, showPhone) => {
  // return false;
  if (localStorage.getItem("user_id") == 0) {
    return new Promise((resolve, reject) => {
      that
        .postRequest({
          service: "App.User.LoginByOpenId",
          openid: localStorage.getItem("openid"),
          unionid: localStorage.getItem("unionid")
            ? localStorage.getItem("unionid")
            : ""
        })
        .then(res => {
          if (res.data.ret == 200) {
            var data = res.data.data;
            localStorage.setItem("nickname", data.nickname);
            localStorage.setItem("token", data.token);
            localStorage.setItem("user_id", data.user_id);
            localStorage.setItem("avatar", data.avatar);
            resolve(true);
          } else {
            if (showPhone) {
              that.$bindPhone();
            }
            resolve(false);
          }
        });
    });
  } else {
    return true;
  }
};

export const gotoAdver = (item, that, fromId) => {
  console.log(fromId);
  var key = item.types;
  switch (key) {
    case "book":
      that.$router.push({
        path: "/course",
        query: {
          bookid: item.param,
          id: item.param
        }
      });
      break;
    case "zl":
      that.$router.push({
        path: "/excellentCourse",
        query: {
          id: item.param,
          fromid: fromId
        }
      });

      break;
    case "link":
      if (item.needuserinfo) {
        location.href = item.param + "?source=wx";
        let obj = {
          nickname: localStorage.getItem("nickname"),
          avatar: localStorage.getItem("avatar")
        };
        if (localStorage.getItem("user_id")) {
          obj.user_id = localStorage.getItem("user_id");
        } else {
          obj.user_id = -1;
        }
        setCookie("userInfo", JSON.stringify(obj));
      } else {
        location.href = item.param;
      }

      break;
    case "youzan":
      // that.$poster.open();
      break;
  }
};
export const weixinshare = (title, des, link, fridendTitle) => {
  var url = window.location.href;
  var innerUrl = url.split("#")[0];
  var that = this;
  return new Promise((resolve, reject) => {
    postRequest({
      service: "App.WxMessage.GetJssdkPara",
      url: innerUrl
    }).then(res => {
      if (res.data.ret == 200) {
        var data = res.data.data;

        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp + "", // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: [
            "updateAppMessageShareData",
            "updateTimelineShareData",
            "onMenuShareWeibo",
            "closeWindow"
          ] // 必填，需要使用的JS接口列表
        });
        resolve("ok");
        wx.ready(function() {
          wx.updateAppMessageShareData({
            title: title, // 分享标题
            desc: des, // 分享描述
            link: link,
            imgUrl: apiConfig().shareImage,
            success: function() {
              // 用户点击了分享后执行的回调函数
            }
          });
          wx.updateTimelineShareData({
            title: fridendTitle ? fridendTitle : title,
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: apiConfig().shareImage, // 分享图标
            success: function() {
              // 设置成功
            }
          });
          wx.onMenuShareWeibo({
            title: title, // 分享标题
            desc: des, // 分享描述
            link: link,
            imgUrl: apiConfig().shareImage,
            success: function() {
              // 用户确认分享后执行的回调函数
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
            }
          });
        });
      }
    });
  });
};

export const forbidShare = () => {
  function onBridgeReady() {
    WeixinJSBridge.call("hideOptionMenu");
  }
  if (typeof WeixinJSBridge == "undefined") {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
      document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
    }
  } else {
    onBridgeReady();
  }
};
export const menuPwdMinxin = {
  data() {
    return {
      // 自定义confrim的底部取消和确定，
      opts: [
        {
          txt: "取消",
          color: "#e6e6e6",
          callback: () => {
            this.send1 = false;
          }
        },
        {
          txt: "确定",
          color: "#ffbc00",
          callback: () => {
            let obj = {
              service: "App.AntHome_AntMember.UpdateForbiddenByAidUid",
              ant_id: this.arrlist[this.send1index].ant_id,
              uid: this.send1uid,
              day: this.datatime,
              action: "add"
            };
            this.postRequest(obj).then(res => {
              this.send1 = false;
              if (res.data.ret == 200) {
                this.$dialog.toast({
                  timeout: 1500,
                  mes: "禁言成功"
                });
                this.arrlist[this.send1index].user.ant_forbidden = 1;
              } else {
                this.$dialog.toast({
                  timeout: 1500,
                  mes: res.data.msg
                });
              }
            });
          }
        }
      ],
      send1uid: 0,
      send1index: -1,
      send1: false, //控制禁言是否显示
      datatime: 1, //禁言天数
      send2: false,
      forbidAdd: false,
      send2index: -1,
      quitopts: [
        {
          txt: "取消",
          color: "#e6e6e6",
          callback: () => {
            this.send2 = false;
          }
        },
        {
          txt: "确定",
          color: "#ffbc00",
          callback: () => {
            let obj = {
              service: "App.AntHome_AntMember.KickoutMember",
              ant_id: this.arrlist[this.send2index].ant_id,
              uid: this.arrlist[this.send2index].user.uid,
              black: this.forbidAdd ? "yes" : "no"
            };
            this.postRequest(obj).then(res => {
              this.send2 = false;
              if (res.data.ret == 200) {
                this.$dialog.toast({
                  timeout: 1500,
                  mes: "踢出成功"
                });
                this.arrlist[this.send2index].user.ant_identify = 0;
              } else {
                this.$dialog.toast({
                  timeout: 1500,
                  mes: res.data.msg
                });
              }
            });
          }
        }
      ]
    };
  },
  methods: {
    // 移除动态；
    async removenew(index) {
      this.$confirm({
        title: "提示",
        mes: `确定要剔除此动态吗？`,
        opts: [
          {
            txt: "取消",
            color: "#e6e6e6",
            callback: () => {}
          },
          {
            txt: "确定",
            stay: true,
            color: "#ffbc00",
            callback: () => {
              pageScroll.unlock();
              this.postRequest({
                service: "App.AntNews_News.Open",
                id: this.arrlist[index].id
              }).then(res => {
                var Element = document.getElementById("confirmContent");
                Element.parentNode.removeChild(Element);

                if (res.data.ret == 200) {
                  this.arrlist.splice(index, 1);
                  // this.arrlist[index].user.ant_forbidden = 0;
                  this.$dialog.toast({
                    timeout: 1500,
                    mes: "移除成功"
                  });
                } else {
                  this.$dialog.toast({
                    timeout: 1500,
                    mes: res.data.msg
                  });
                }
              });
            }
          }
        ]
      });
      //
    },
    // 精华
    async setTop(num, index) {
      this.arrlist[index].istop = num;
    },
    // 禁言
    banned(num, index) {
      this.send1index = index;
      if (num == 0) {
        this.send1 = true;
        this.send1uid = this.arrlist[index].user.uid;
      } else {
        this.$confirm({
          title: "提示",
          mes: `确定要解除 ${this.arrlist[index].user.nickname} 的禁言吗？`,
          opts: [
            {
              txt: "取消",
              color: "#e6e6e6",
              callback: () => {}
            },
            {
              txt: "确定",
              stay: true,
              color: "#ffbc00",
              callback: () => {
                pageScroll.unlock();
                let obj = {
                  service: "App.AntHome_AntMember.UpdateForbiddenByAidUid",
                  ant_id: this.arrlist[index].ant_id,
                  uid: this.arrlist[index].user.uid,
                  day: 0,
                  action: "del"
                };
                this.postRequest(obj).then(res => {
                  var Element = document.getElementById("confirmContent");
                  Element.parentNode.removeChild(Element);

                  if (res.data.ret == 200) {
                    this.arrlist[index].user.ant_forbidden = 0;
                    this.$dialog.toast({
                      timeout: 1500,
                      mes: "解除禁言成功"
                    });
                  } else {
                    this.$dialog.toast({
                      timeout: 1500,
                      mes: res.data.msg
                    });
                  }
                });
              }
            }
          ]
        });
      }
    },
    // 设置管理员
    async setAdmin(num, index) {
      this.arrlist[index].user.ant_identify = num;
    },
    //  删除动态
    del(index) {
      this.$confirm({
        title: "提示",
        mes: `确定要删除此动态吗？`,
        opts: [
          {
            txt: "取消",
            color: "#e6e6e6",
            callback: () => {}
          },
          {
            txt: "确定",
            stay: true,
            color: "#ffbc00",
            callback: () => {
              pageScroll.unlock();
              let obj = {
                service: "App.AntNews_News.Del",
                id: this.arrlist[index].id
              };

              this.postRequest(obj).then(res => {
                var Element = document.getElementById("confirmContent");
                Element.parentNode.removeChild(Element);

                if (res.data.ret == 200) {
                  this.arrlist.splice(index, 1);
                  // this.arrlist[index].user.ant_forbidden = 0;
                  this.$dialog.toast({
                    timeout: 1500,
                    mes: "删除动态成功"
                  });
                } else {
                  this.$dialog.toast({
                    timeout: 1500,
                    mes: res.data.msg
                  });
                }
              });
            }
          }
        ]
      });
    },
    // 退出蚁窝
    quit(index) {
      // console.log("删除蚁窝");
      this.send2 = true;
      this.forbidAdd = false;
      this.send2index = index;
    }
  }
};
